// extracted by mini-css-extract-plugin
export default {"copy":"parent-product-message__copy___3Zzsn"};